module.exports = __webpack_public_path__ + "img/_pour-wine.32391169.png";